import Icon, { CheckCircleFilled } from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as ACH } from 'assets/icons/ach.svg';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg';
import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg';
import { ReactComponent as Brush } from 'assets/icons/brush.svg';
import { ReactComponent as BtnBack } from 'assets/icons/btn-back.svg';
import { ReactComponent as BtnNext } from 'assets/icons/btn-next.svg';
import { ReactComponent as Calendar } from 'assets/icons/calendar.svg';
import { ReactComponent as CardCheck } from 'assets/icons/card-check.svg';
import { ReactComponent as Card } from 'assets/icons/card.svg';
import { ReactComponent as InternalBilling } from 'assets/icons/internal-billing.svg';
import { ReactComponent as CaretDown } from 'assets/icons/caret-down.svg';
import { ReactComponent as CaretUp } from 'assets/icons/caret-up.svg';
import { ReactComponent as CartEmpty } from 'assets/icons/cart-empty.svg';
import { ReactComponent as Cart } from 'assets/icons/cart.svg';
import { ReactComponent as Chat } from 'assets/icons/chat.svg';
import { ReactComponent as CheckSmall } from 'assets/icons/check-small.svg';
import { ReactComponent as CheckSquareChecked } from 'assets/icons/check-square-checked.svg';
import { ReactComponent as CheckSquareUnChecked } from 'assets/icons/check-square-unchecked.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as CompanyModalClose } from 'assets/icons/company-modal-close.svg';
import { ReactComponent as ConfirmShippingDelete } from 'assets/icons/confirm-shipping-delete.svg';
import { ReactComponent as Delete } from 'assets/icons/delete.svg';
import { ReactComponent as DisabledCircle } from 'assets/icons/disabled-circle.svg';
import { ReactComponent as DoneCircle } from 'assets/icons/done-circle.svg';
import { ReactComponent as Edit } from 'assets/icons/edit.svg';
import { ReactComponent as ErrorExclamationPoint } from 'assets/icons/error-exclamation-point.svg';
import { ReactComponent as ExpertVersionnAdd } from 'assets/icons/expert-versionn-add.svg';
import { ReactComponent as ExpertVersionnDelete } from 'assets/icons/expert-versionn-delete.svg';
import { ReactComponent as FileDelete } from 'assets/icons/file-delete.svg';
import { ReactComponent as FileDownload } from 'assets/icons/file-download.svg';
import { ReactComponent as FilePDF } from 'assets/icons/file-pdf.svg';
import { ReactComponent as Ai } from 'assets/icons/file-types/ai-icon.svg';
import { ReactComponent as DefaultFileType } from 'assets/icons/file-types/default-icon.svg';
import { ReactComponent as Doc } from 'assets/icons/file-types/doc-icon.svg';
import { ReactComponent as Docx } from 'assets/icons/file-types/docx-icon.svg';
import { ReactComponent as Eps } from 'assets/icons/file-types/eps-icon.svg';
import { ReactComponent as Gif } from 'assets/icons/file-types/gif-icon.svg';
import { ReactComponent as Id } from 'assets/icons/file-types/id-icon.svg';
import { ReactComponent as Jpeg } from 'assets/icons/file-types/jpeg-icon.svg';
import { ReactComponent as Jpg } from 'assets/icons/file-types/jpg-icon.svg';
import { ReactComponent as Pdf } from 'assets/icons/file-types/pdf-icon.svg';
import { ReactComponent as Png } from 'assets/icons/file-types/png-icon.svg';
import { ReactComponent as Ppt } from 'assets/icons/file-types/ppt-icon.svg';
import { ReactComponent as Pptx } from 'assets/icons/file-types/pptx-icon.svg';
import { ReactComponent as Psd } from 'assets/icons/file-types/psd-icon.svg';
import { ReactComponent as Rar } from 'assets/icons/file-types/rar-icon.svg';
import { ReactComponent as Svg } from 'assets/icons/file-types/svg-icon.svg';
import { ReactComponent as Tif } from 'assets/icons/file-types/tif-icon.svg';
import { ReactComponent as Tiff } from 'assets/icons/file-types/tiff-icon.svg';
import { ReactComponent as Xls } from 'assets/icons/file-types/xls-icon.svg';
import { ReactComponent as Xlsx } from 'assets/icons/file-types/xlsx-icon.svg';
import { ReactComponent as Zip } from 'assets/icons/file-types/zip-icon.svg';
import { ReactComponent as FilterTips } from 'assets/icons/filter-tips.svg';
import { ReactComponent as Filter } from 'assets/icons/filter.svg';
import { ReactComponent as GalleryCard } from 'assets/icons/gallery-card.svg';
import { ReactComponent as GalleryList } from 'assets/icons/gallery-list.svg';
import { ReactComponent as Help } from 'assets/icons/help.svg';
import { ReactComponent as JobExpiredTip } from 'assets/icons/job-expired-tip.svg';
import { ReactComponent as JobQuoteTrash } from 'assets/icons/job-quote-trash.svg';
import { ReactComponent as JobconfigAddQuantity } from 'assets/icons/jobconfig/jobconfig-add-quantity.svg';
import { ReactComponent as JobconfigAdditionalBlock } from 'assets/icons/jobconfig/jobconfig-additional-black.svg';
import { ReactComponent as JobconfigAdditionalCmyk } from 'assets/icons/jobconfig/jobconfig-additional-cmyk.svg';
import { ReactComponent as JobconfigAdditionalColor } from 'assets/icons/jobconfig/jobconfig-additional-color.svg';
import { ReactComponent as JobconfigAdditionalNone } from 'assets/icons/jobconfig/jobconfig-additional-none.svg';
import { ReactComponent as JobconfigBannerCornersOnly } from 'assets/icons/jobconfig/jobconfig-banner-cornersOnly.svg';
import { ReactComponent as JobconfigBannerEveryFeet } from 'assets/icons/jobconfig/jobconfig-banner-everyFeet.svg';
import { ReactComponent as JobconfigBannerHemming } from 'assets/icons/jobconfig/jobconfig-banner-hemming.svg';
import { ReactComponent as JobconfigBindingCoilLongLeft } from 'assets/icons/jobconfig/jobconfig-binding-coil-long-left.svg';
import { ReactComponent as JobconfigBindingCoilLongRight } from 'assets/icons/jobconfig/jobconfig-binding-coil-long-right.svg';
import { ReactComponent as JobconfigBindingCoilShortLeft } from 'assets/icons/jobconfig/jobconfig-binding-coil-short-left.svg';
import { ReactComponent as JobconfigBindingCoilShortRight } from 'assets/icons/jobconfig/jobconfig-binding-coil-short-right.svg';
import { ReactComponent as JobconfigBindingCombLongLeft } from 'assets/icons/jobconfig/jobconfig-binding-comb-long-left.svg';
import { ReactComponent as JobconfigBindingCombLongRight } from 'assets/icons/jobconfig/jobconfig-binding-comb-long-right.svg';
import { ReactComponent as JobconfigBindingCombShortLeft } from 'assets/icons/jobconfig/jobconfig-binding-comb-short-left.svg';
import { ReactComponent as JobconfigBindingCombShortRight } from 'assets/icons/jobconfig/jobconfig-binding-comb-short-right.svg';
import { ReactComponent as JobconfigBindingCornerLowerLeftLeft } from 'assets/icons/jobconfig/jobconfig-binding-corner-lowerLeft-left.svg';
import { ReactComponent as JobconfigBindingCornerLowerLeftRight } from 'assets/icons/jobconfig/jobconfig-binding-corner-lowerLeft-right.svg';
import { ReactComponent as JobconfigBindingCornerLowerRightLeft } from 'assets/icons/jobconfig/jobconfig-binding-corner-lowerRight-left.svg';
import { ReactComponent as JobconfigBindingCornerLowerRightRight } from 'assets/icons/jobconfig/jobconfig-binding-corner-lowerRight-right.svg';
import { ReactComponent as JobconfigBindingCornerUpperLeftLeft } from 'assets/icons/jobconfig/jobconfig-binding-corner-upperLeft-left.svg';
import { ReactComponent as JobconfigBindingCornerUpperLeftRight } from 'assets/icons/jobconfig/jobconfig-binding-corner-upperLeft-right.svg';
import { ReactComponent as JobconfigBindingCornerUpperRightLeft } from 'assets/icons/jobconfig/jobconfig-binding-corner-upperRight-left.svg';
import { ReactComponent as JobconfigBindingCornerUpperRightRight } from 'assets/icons/jobconfig/jobconfig-binding-corner-upperRight-right.svg';
import { ReactComponent as JobconfigBindingDRing } from 'assets/icons/jobconfig/jobconfig-binding-dRing.svg';
import { ReactComponent as JobconfigBindingLoopLongLeft } from 'assets/icons/jobconfig/jobconfig-binding-loop-long-left.svg';
import { ReactComponent as JobconfigBindingLoopLongRight } from 'assets/icons/jobconfig/jobconfig-binding-loop-long-right.svg';
import { ReactComponent as JobconfigBindingLoopShortLeft } from 'assets/icons/jobconfig/jobconfig-binding-loop-short-left.svg';
import { ReactComponent as JobconfigBindingLoopShortRight } from 'assets/icons/jobconfig/jobconfig-binding-loop-short-right.svg';
import { ReactComponent as JobconfigBindingPerfectBoundLongLeft } from 'assets/icons/jobconfig/jobconfig-binding-perfectBound-long-left.svg';
import { ReactComponent as JobconfigBindingPerfectBoundLongRight } from 'assets/icons/jobconfig/jobconfig-binding-perfectBound-long-right.svg';
import { ReactComponent as JobconfigBindingPerfectBoundShortLeft } from 'assets/icons/jobconfig/jobconfig-binding-perfectBound-short-left.svg';
import { ReactComponent as JobconfigBindingPerfectBoundShortRight } from 'assets/icons/jobconfig/jobconfig-binding-perfectBound-short-right.svg';
import { ReactComponent as JobconfigBindingProClickLongLeft } from 'assets/icons/jobconfig/jobconfig-binding-proClick-long-left.svg';
import { ReactComponent as JobconfigBindingProClickLongRight } from 'assets/icons/jobconfig/jobconfig-binding-proClick-long-right.svg';
import { ReactComponent as JobconfigBindingProClickShortLeft } from 'assets/icons/jobconfig/jobconfig-binding-proClick-short-left.svg';
import { ReactComponent as JobconfigBindingProClickShortRight } from 'assets/icons/jobconfig/jobconfig-binding-proClick-short-right.svg';
import { ReactComponent as JobconfigBindingRoundRing } from 'assets/icons/jobconfig/jobconfig-binding-roundRing.svg';
import { ReactComponent as JobconfigBindingTapeLongLeft } from 'assets/icons/jobconfig/jobconfig-binding-tape-long-left.svg';
import { ReactComponent as JobconfigBindingTapeLongRight } from 'assets/icons/jobconfig/jobconfig-binding-tape-long-right.svg';
import { ReactComponent as JobconfigBindingTapeShortLeft } from 'assets/icons/jobconfig/jobconfig-binding-tape-short-left.svg';
import { ReactComponent as JobconfigBindingTapeShortRight } from 'assets/icons/jobconfig/jobconfig-binding-tape-short-right.svg';
import { ReactComponent as JobconfigDelete } from 'assets/icons/jobconfig/jobconfig-delete.svg';
import { ReactComponent as JobconfigOverquoteEdit } from 'assets/icons/jobconfig/jobconfig-overquote-edit.svg';
import { ReactComponent as JobconfigPaperBack } from 'assets/icons/jobconfig/jobconfig-paper-back.svg';
import { ReactComponent as JobconfigPaperErrorTag } from 'assets/icons/jobconfig/jobconfig-paper-errorTag.svg';
import { ReactComponent as JobconfigPaperNext } from 'assets/icons/jobconfig/jobconfig-paper-next.svg';
import { ReactComponent as JobconfigPaperPre } from 'assets/icons/jobconfig/jobconfig-paper-pre.svg';
import { ReactComponent as JobconfigPolygon } from 'assets/icons/jobconfig/jobconfig-polygon.svg';
import { ReactComponent as JobconfigPrintingTip } from 'assets/icons/jobconfig/jobconfig-printing-tip.svg';
import { ReactComponent as JobconfigRoundBase } from 'assets/icons/jobconfig/jobconfig-round-base.svg';
import { ReactComponent as JobconfigSupplierComparisonArrow } from 'assets/icons/jobconfig/jobconfig-supplier-comparison-arrow.svg';
import { ReactComponent as JobconfigVersionAdd } from 'assets/icons/jobconfig/jobconfig-version-add.svg';
import { ReactComponent as JobconfigVersionDelete } from 'assets/icons/jobconfig/jobconfig-version-delete.svg';
import { ReactComponent as JobconfigViewQuoteDelete } from 'assets/icons/jobconfig/jobconfig-viewQuote-delete.svg';
import { ReactComponent as LeftOutlined } from 'assets/icons/left-outlined.svg';
import { ReactComponent as MessageError } from 'assets/icons/message-error.svg';
import { ReactComponent as MessageInfo } from 'assets/icons/message-info.svg';
import { ReactComponent as MessageSuccess } from 'assets/icons/message-success.svg';
import { ReactComponent as MessageWarning } from 'assets/icons/message-warning.svg';
import { ReactComponent as Note } from 'assets/icons/note.svg';
import { ReactComponent as Notification } from 'assets/icons/notification.svg';
import { ReactComponent as Order } from 'assets/icons/order-icon.svg';
import { ReactComponent as OrderLater } from 'assets/icons/order-later.svg';
import { ReactComponent as PlayLeft } from 'assets/icons/play-left.svg';
import { ReactComponent as PlayRight } from 'assets/icons/play-right.svg';
import { ReactComponent as PlayUp } from 'assets/icons/play-up.svg';
import { ReactComponent as PlusCircle } from 'assets/icons/plus-circle.svg';
import { ReactComponent as ProjectAdd } from 'assets/icons/project-add.svg';
import { ReactComponent as ProjectCardDefault } from 'assets/icons/project-card-default.svg';
import { ReactComponent as ProjectCopy } from 'assets/icons/project-copy.svg';
import { ReactComponent as ProjectDelete } from 'assets/icons/project-delete.svg';
import { ReactComponent as ProjectPdf } from 'assets/icons/project-pdf.svg';
import { ReactComponent as ProjectSort } from 'assets/icons/project-sort.svg';
import { ReactComponent as ProjectView } from 'assets/icons/project-view.svg';
import { ReactComponent as RadioChecked } from 'assets/icons/radio-checked.svg';
import { ReactComponent as RadioUncheckedCrude } from 'assets/icons/radio-unchecked-crude.svg';
import { ReactComponent as RadioUnchecked } from 'assets/icons/radio-unchecked.svg';
import { ReactComponent as RfmFindSupplier } from 'assets/icons/rfm-find-supplier.svg';
import { ReactComponent as RfqCheck } from 'assets/icons/rfq-check.svg';
import { ReactComponent as RfqDown } from 'assets/icons/rfq-down.svg';
import { ReactComponent as RFQTableWarning } from 'assets/icons/rfq-send-table-warning.svg';
import { ReactComponent as RFQWarning } from 'assets/icons/rfq-send-warning.svg';
import { ReactComponent as RfqUncheck } from 'assets/icons/rfq-uncheck.svg';
import { ReactComponent as RightOutlined } from 'assets/icons/right-outlined.svg';
import { ReactComponent as SavedQuotes } from 'assets/icons/saved-quotes.svg';
import { ReactComponent as Selected } from 'assets/icons/selected.svg';
import { ReactComponent as SideLeft } from 'assets/icons/side-left.svg';
import { ReactComponent as SideRight } from 'assets/icons/side-right.svg';
import { ReactComponent as Trash } from 'assets/icons/trash.svg';
import { ReactComponent as UncheckedCircle } from 'assets/icons/unchecked-circle.svg';
import { ReactComponent as UploadDelete } from 'assets/icons/upload-delete-icon.svg';
import { ReactComponent as UploadDown } from 'assets/icons/upload-down-icon.svg';
import { ReactComponent as Vector } from 'assets/icons/vector.svg';
import { ReactComponent as Wire } from 'assets/icons/wire.svg';
import { ReactComponent as Drag } from 'assets/icons/projects/drag.svg';
import { ReactComponent as ProjectFilter } from 'assets/icons/projects/filter.svg';
import ShippingIconUPS from 'assets/icons/shipping/UPS.svg';
import ShippingIconFedEx from 'assets/icons/shipping/FedEx.svg';
import classnames from 'classnames';
import { omit } from 'lodash-es';
import './index.less';

type IconType = React.ComponentType<
  CustomIconComponentProps | React.SVGProps<SVGSVGElement>
>;

interface DefaultProps {
  className?: string;
  fill?: string;
}

interface SelectableIconProps extends Partial<CustomIconComponentProps> {
  selected?: boolean;
  onSelect?: (selected: boolean) => void;
  checkIconPosition?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}
const buildIcon = (IconComponent: IconType, defaultProps?: DefaultProps) => {
  return (props: Partial<CustomIconComponentProps>) => (
    <Icon
      component={() => {
        return (
          <IconComponent
            {...omit(props, ['className'])}
            width={props?.width || '1em'}
            height={props?.height || '1em'}
            fill={props?.fill || defaultProps?.fill || 'currentColor'}
          />
        );
      }}
      className={classnames(
        'revx-icon',
        defaultProps?.className,
        props?.className
      )}
    />
  );
};
const buildSelectableIcon = (
  IconComponent: IconType,
  defaultProps?: DefaultProps
) => {
  return (props: SelectableIconProps) => {
    const {
      selected,
      onSelect,
      checkIconPosition = 'top-right',
      ...iconProps
    } = props;

    // 如果有选中相关属性，返回可选择的版本
    if (selected !== undefined || onSelect) {
      return (
        <div
          className={classnames('selectable-icon-wrapper', {
            selected: selected,
          })}
          style={{
            position: 'relative',
            display: 'inline-block',
            cursor: onSelect ? 'pointer' : 'default',
          }}
          onClick={() => onSelect && onSelect(!selected)}
        >
          <Icon
            component={() => (
              <IconComponent
                {...omit(iconProps, [
                  'className',
                  'selected',
                  'onSelect',
                  'checkIconPosition',
                ])}
                width={iconProps?.width || '1em'}
                height={iconProps?.height || '1em'}
                fill={iconProps?.fill || defaultProps?.fill || 'currentColor'}
              />
            )}
            className={classnames(
              'revx-icon',
              defaultProps?.className,
              iconProps?.className,
              { 'icon-selected': selected }
            )}
            style={{
              opacity: selected ? 0.8 : 1,
            }}
          />

          {/* 只有在 selected 为 true 时才显示绿色勾选符号 */}
          {selected && (
            <CheckCircleFilled
              className={classnames(
                'selection-check',
                `position-${checkIconPosition}`
              )}
              style={{
                position: 'absolute',
                color: '#52B3A7', // 绿色
                fontSize: '12px',
                backgroundColor: 'white',
                borderRadius: '50%',
                ...(checkIconPosition === 'top-right' && {
                  top: -4,
                  right: -4,
                }),
                ...(checkIconPosition === 'top-left' && { top: -4, left: -4 }),
                ...(checkIconPosition === 'bottom-right' && {
                  bottom: -4,
                  right: -4,
                }),
                ...(checkIconPosition === 'bottom-left' && {
                  bottom: -4,
                  left: -4,
                }),
              }}
            />
          )}
        </div>
      );
    }

    // 普通 Icon（无选中功能）
    return (
      <Icon
        component={() => (
          <IconComponent
            {...omit(iconProps, ['className'])}
            width={iconProps?.width || '1em'}
            height={iconProps?.height || '1em'}
            fill={iconProps?.fill || defaultProps?.fill || 'currentColor'}
          />
        )}
        className={classnames(
          'revx-icon',
          defaultProps?.className,
          iconProps?.className
        )}
        style={{
          cursor: 'onClick' in iconProps ? 'pointer' : 'default',
          ...iconProps.style,
        }}
      />
    );
  };
};

const buildIconWithImage = (src: string) => {
  return <img src={src} alt="icon" />;
};

export const ArrowDownIcon = buildIcon(ArrowDown, { fill: 'none' });
export const ArrowUpIcon = buildIcon(ArrowUp, { fill: 'none' });
export const ArrowLeftIcon = buildIcon(ArrowLeft, { fill: 'none' });
export const CartIcon = buildIcon(Cart);
export const OrderLaterIcon = buildIcon(OrderLater);
export const CartEmptyIcon = buildIcon(CartEmpty);
export const AddIcon = buildIcon(Add);
export const CloseIcon = buildIcon(Close);
export const MessageErrorIcon = buildIcon(MessageError);
export const MessageSuccessIcon = buildIcon(MessageSuccess);
export const MessageWarningIcon = buildIcon(MessageWarning);
export const MessageInfoIcon = buildIcon(MessageInfo);
export const SelectedIcon = buildIcon(Selected);
export const PlusCircleIcon = buildIcon(PlusCircle);
export const EditIcon = buildIcon(Edit);
export const FilePDFIcon = buildIcon(FilePDF);
export const ChatIcon = buildIcon(Chat);
export const OrderIcon = buildIcon(Order);
export const DeleteIcon = buildIcon(Delete);
export const CaretDownIcon = buildIcon(CaretDown);
export const CaretUpIcon = buildIcon(CaretUp);
export const FilterIcon = buildIcon(Filter);
export const BrushIcon = buildIcon(Brush);
export const SideLeftIcon = buildIcon(SideLeft);
export const SideRightIcon = buildIcon(SideRight);
export const DoneCircleIcon = buildIcon(DoneCircle);
export const UncheckedCircleIcon = buildIcon(UncheckedCircle);
export const CheckSmallIcon = buildIcon(CheckSmall, { fill: 'none' });
export const SavedQuotesIcon = buildIcon(SavedQuotes, { fill: 'none' });
export const RfmFindSupplierIcon = buildIcon(RfmFindSupplier, { fill: 'none' });
export const AiIcon = buildIcon(Ai);
export const DocIcon = buildIcon(Doc);
export const DocxIcon = buildIcon(Docx);
export const EpsIcon = buildIcon(Eps);
export const GifIcon = buildIcon(Gif);
export const IdIcon = buildIcon(Id);
export const JpegIcon = buildIcon(Jpeg);
export const JpgIcon = buildIcon(Jpg);
export const PdfIcon = buildIcon(Pdf);
export const PngIcon = buildIcon(Png);
export const PptIcon = buildIcon(Ppt);
export const PptxIcon = buildIcon(Pptx);
export const PsdIcon = buildIcon(Psd);
export const RarIcon = buildIcon(Rar);
export const SvgIcon = buildIcon(Svg);
export const TifIcon = buildIcon(Tif);
export const TiffIcon = buildIcon(Tiff);
export const XlsIcon = buildIcon(Xls);
export const XlsxIcon = buildIcon(Xlsx);
export const ZipIcon = buildIcon(Zip);
export const DefaultFileTypeIcon = buildIcon(DefaultFileType);
export const UploadDeleteIcon = buildIcon(UploadDelete, { fill: 'none' });
export const UploadDownIcon = buildIcon(UploadDown, { fill: 'none' });
export const BtnBackIcon = buildIcon(BtnBack);
export const BtnNextIcon = buildIcon(BtnNext);
export const RadioCheckedIcon = buildIcon(RadioChecked);
export const RadioUncheckedIcon = buildIcon(RadioUnchecked, { fill: 'none' });
export const RadioUncheckedCrudeIcon = buildIcon(RadioUncheckedCrude, {
  fill: 'none',
});
export const HelpIcon = buildIcon(Help);
export const JobconfigAddQuantityIcon = buildIcon(JobconfigAddQuantity);
export const JobconfigDeleteIcon = buildIcon(JobconfigDelete, { fill: 'none' });
export const JobconfigVersionDeleteIcon = buildIcon(JobconfigVersionDelete);
export const JobconfigVersionAddIcon = buildIcon(JobconfigVersionAdd);
export const JobconfigPolygonIcon = buildIcon(JobconfigPolygon);
export const PlayLeftIcon = buildIcon(PlayLeft);
export const PlayRightIcon = buildIcon(PlayRight);
export const PlayUpIcon = buildIcon(PlayUp);
export const JobconfigPaperPreIcon = buildIcon(JobconfigPaperPre);
export const JobconfigPaperNextIcon = buildIcon(JobconfigPaperNext);
export const JobconfigPaperBackIcon = buildIcon(JobconfigPaperBack, {
  fill: 'none',
});
export const CalendarIcon = buildIcon(Calendar, { fill: 'none' });
export const JobconfigAdditionalCmykIcon = buildIcon(JobconfigAdditionalCmyk);
export const JobconfigAdditionalBlockIcon = buildIcon(JobconfigAdditionalBlock);
export const JobconfigAdditionalNoneIcon = buildIcon(JobconfigAdditionalNone);
export const JobconfigAdditionalColorIcon = buildIcon(JobconfigAdditionalColor);
export const JobconfigPrintingTipIcon = buildIcon(JobconfigPrintingTip);
export const TrashIcon = buildIcon(Trash);
export const JobconfigOverquoteEditIcon = buildIcon(JobconfigOverquoteEdit, {
  fill: 'none',
});
export const JobconfigSupplierComparisonArrowIcon = buildIcon(
  JobconfigSupplierComparisonArrow
);
export const FileDownloadIcon = buildIcon(FileDownload);
export const FileDeleteIcon = buildIcon(FileDelete);
export const JobconfigViewQuoteDeleteIcon = buildIcon(JobconfigViewQuoteDelete);
export const JobconfigBindingCoilLongLeftIcon = buildIcon(
  JobconfigBindingCoilLongLeft
);
export const JobconfigBindingCoilLongRightIcon = buildIcon(
  JobconfigBindingCoilLongRight
);
export const JobconfigBindingCoilShortLeftIcon = buildIcon(
  JobconfigBindingCoilShortLeft
);
export const JobconfigBindingCoilShortRightIcon = buildIcon(
  JobconfigBindingCoilShortRight
);
export const JobconfigBindingCombLongLeftIcon = buildIcon(
  JobconfigBindingCombLongLeft
);
export const JobconfigBindingCombLongRightIcon = buildIcon(
  JobconfigBindingCombLongRight
);
export const JobconfigBindingCombShortLeftIcon = buildIcon(
  JobconfigBindingCombShortLeft
);
export const JobconfigBindingCombShortRightIcon = buildIcon(
  JobconfigBindingCombShortRight
);
export const JobconfigBindingTapeLongLeftIcon = buildIcon(
  JobconfigBindingTapeLongLeft
);
export const JobconfigBindingTapeLongRightIcon = buildIcon(
  JobconfigBindingTapeLongRight
);
export const JobconfigBindingTapeShortLeftIcon = buildIcon(
  JobconfigBindingTapeShortLeft
);
export const JobconfigBindingTapeShortRightIcon = buildIcon(
  JobconfigBindingTapeShortRight
);
export const JobconfigBindingLoopLongLeftIcon = buildIcon(
  JobconfigBindingLoopLongLeft
);
export const JobconfigBindingLoopLongRightIcon = buildIcon(
  JobconfigBindingLoopLongRight
);
export const JobconfigBindingLoopShortLeftIcon = buildIcon(
  JobconfigBindingLoopShortLeft
);
export const JobconfigBindingLoopShortRightIcon = buildIcon(
  JobconfigBindingLoopShortRight
);
export const JobconfigBindingProClickLongLeftIcon = buildIcon(
  JobconfigBindingProClickLongLeft
);
export const JobconfigBindingProClickLongRightIcon = buildIcon(
  JobconfigBindingProClickLongRight
);
export const JobconfigBindingProClickShortLeftIcon = buildIcon(
  JobconfigBindingProClickShortLeft
);
export const JobconfigBindingProClickShortRightIcon = buildIcon(
  JobconfigBindingProClickShortRight
);
export const JobconfigBindingPerfectBoundLongLeftIcon = buildIcon(
  JobconfigBindingPerfectBoundLongLeft
);
export const JobconfigBindingPerfectBoundLongRightIcon = buildIcon(
  JobconfigBindingPerfectBoundLongRight
);
export const JobconfigBindingPerfectBoundShortLeftIcon = buildIcon(
  JobconfigBindingPerfectBoundShortLeft
);
export const JobconfigBindingPerfectBoundShortRightIcon = buildIcon(
  JobconfigBindingPerfectBoundShortRight
);
export const JobconfigBindingCornerLowerLeftLeftIcon = buildIcon(
  JobconfigBindingCornerLowerLeftLeft
);
export const JobconfigBindingCornerLowerLeftRightIcon = buildIcon(
  JobconfigBindingCornerLowerLeftRight
);
export const JobconfigBindingCornerLowerRightLeftIcon = buildIcon(
  JobconfigBindingCornerLowerRightLeft
);
export const JobconfigBindingCornerLowerRightRightIcon = buildIcon(
  JobconfigBindingCornerLowerRightRight
);
export const JobconfigBindingCornerUpperLeftLeftIcon = buildIcon(
  JobconfigBindingCornerUpperLeftLeft
);
export const JobconfigBindingCornerUpperLeftRightIcon = buildIcon(
  JobconfigBindingCornerUpperLeftRight
);
export const JobconfigBindingCornerUpperRightLeftIcon = buildIcon(
  JobconfigBindingCornerUpperRightLeft
);
export const JobconfigBindingCornerUpperRightRightIcon = buildIcon(
  JobconfigBindingCornerUpperRightRight
);
export const JobconfigBindingDRingIcon = buildIcon(JobconfigBindingDRing);
export const JobconfigBindingRoundRingIcon = buildIcon(
  JobconfigBindingRoundRing
);
export const JobconfigPaperErrorTagIcon = buildIcon(JobconfigPaperErrorTag);
export const JobconfigBannerEveryFeetIcon = buildIcon(JobconfigBannerEveryFeet);
export const JobconfigBannerCornersOnlyIcon = buildIcon(
  JobconfigBannerCornersOnly
);
export const JobconfigBannerHemmingIcon = buildIcon(JobconfigBannerHemming);
export const JobconfigRoundBaseIcon = buildIcon(JobconfigRoundBase);
export const DisabledCircleIcon = buildIcon(DisabledCircle);
export const NotificationIcon = buildIcon(Notification);
export const JobExpiredTipIcon = buildIcon(JobExpiredTip);
export const JobQuoteTrashIcon = buildIcon(JobQuoteTrash);
export const CheckSquareCheckedIcon = buildIcon(CheckSquareChecked, {
  fill: 'none',
});
export const CheckSquareUnCheckedIcon = buildIcon(CheckSquareUnChecked, {
  fill: 'none',
});
export const CardIcon = buildSelectableIcon(Card);
export const ACHIcon = buildSelectableIcon(ACH);
export const WireIcon = buildSelectableIcon(Wire);
export const CardCheckIcon = buildSelectableIcon(CardCheck);
export const InternalBillingIcon = buildSelectableIcon(InternalBilling);
export const ErrorExclamationPointIcon = buildIcon(ErrorExclamationPoint);
export const RfqCheckIcon = buildIcon(RfqCheck);
export const RfqUncheckIcon = buildIcon(RfqUncheck);
export const RfqDownIcon = buildIcon(RfqDown, {
  fill: 'none',
});
export const ExpertVersionnAddIcon = buildIcon(ExpertVersionnAdd, {
  fill: 'none',
});
export const ExpertVersionnDeleteIcon = buildIcon(ExpertVersionnDelete, {
  fill: 'none',
});
export const VectorIcon = buildIcon(Vector, {
  fill: 'none',
});
export const RFQWarningIcon = buildIcon(RFQWarning, {
  fill: 'none',
});
export const RFQTableWarningIcon = buildIcon(RFQTableWarning, {
  fill: 'none',
});
export const NoteIcon = buildIcon(Note, {
  fill: 'none',
});
export const LeftOutlinedIcon = buildIcon(LeftOutlined, {
  fill: 'none',
});
export const RightOutlinedIcon = buildIcon(RightOutlined, {
  fill: 'none',
});
export const FilterTipsIcon = buildIcon(FilterTips, {
  fill: 'none',
});
export const GalleryListIcon = buildIcon(GalleryList, {
  fill: 'none',
});
export const GalleryCardIcon = buildIcon(GalleryCard, {
  fill: 'none',
});
export const CompanyModalCloseIcon = buildIcon(CompanyModalClose, {
  fill: 'none',
});
export const ProjectAddIcon = buildIcon(ProjectAdd, {
  fill: 'none',
});
export const ProjectSortIcon = buildIcon(ProjectSort, {
  fill: 'none',
});
export const ProjectJobDragIcon = buildIcon(Drag, {
  fill: 'none',
});
export const ProjectCopyIcon = buildIcon(ProjectCopy, {
  fill: 'none',
});
export const ProjectDeleteIcon = buildIcon(ProjectDelete, {
  fill: 'none',
});
export const ProjectPdfIcon = buildIcon(ProjectPdf, {
  fill: 'none',
});
export const ProjectViewIcon = buildIcon(ProjectView, {
  fill: 'none',
});
export const ProjectCardDefaultIcon = buildIcon(ProjectCardDefault, {
  fill: 'none',
});
export const ConfirmShippingDeleteIcon = buildIcon(ConfirmShippingDelete, {
  fill: 'none',
});
export const ProjectSearchFilterIcon = buildIcon(ProjectFilter);

export const ShippingFedExIcon = buildIconWithImage(ShippingIconFedEx);

export const ShippingUPSIcon = buildIconWithImage(ShippingIconUPS);

export const Icons = {
  ArrowDownIcon,
  CartIcon,
  CartEmptyIcon,
  AddIcon,
  EditIcon,
  ChatIcon,
  OrderIcon,
  CheckSmallIcon,
  DeleteIcon,
  OrderLaterIcon,
  ArrowUpIcon,
  SavedQuotesIcon,
  RfmFindSupplierIcon,
  AiIcon,
  DocIcon,
  DocxIcon,
  EpsIcon,
  GifIcon,
  IdIcon,
  JpegIcon,
  JpgIcon,
  PdfIcon,
  PngIcon,
  PptIcon,
  PptxIcon,
  PsdIcon,
  RarIcon,
  SvgIcon,
  TifIcon,
  TiffIcon,
  XlsIcon,
  XlsxIcon,
  ZipIcon,
  DefaultFileTypeIcon,
  UploadDeleteIcon,
  UploadDownIcon,
  RadioCheckedIcon,
  RadioUncheckedIcon,
  RadioUncheckedCrudeIcon,
  JobconfigAddQuantityIcon,
  JobconfigDeleteIcon,
  JobconfigVersionDeleteIcon,
  JobconfigVersionAddIcon,
  JobconfigPolygonIcon,
  JobconfigPaperPreIcon,
  JobconfigPaperNextIcon,
  JobconfigPaperBackIcon,
  CalendarIcon,
  JobconfigAdditionalCmykIcon,
  JobconfigAdditionalBlockIcon,
  JobconfigAdditionalNoneIcon,
  JobconfigAdditionalColorIcon,
  JobconfigPrintingTipIcon,
  TrashIcon,
  JobconfigOverquoteEditIcon,
  JobconfigSupplierComparisonArrowIcon,
  JobconfigViewQuoteDeleteIcon,
  JobconfigBindingCoilLongLeftIcon,
  JobconfigBindingCoilLongRightIcon,
  JobconfigBindingCoilShortLeftIcon,
  JobconfigBindingCoilShortRightIcon,
  JobconfigBindingCombLongLeftIcon,
  JobconfigBindingCombLongRightIcon,
  JobconfigBindingCombShortLeftIcon,
  JobconfigBindingCombShortRightIcon,
  JobconfigBindingTapeLongLeftIcon,
  JobconfigBindingTapeLongRightIcon,
  JobconfigBindingTapeShortLeftIcon,
  JobconfigBindingTapeShortRightIcon,
  JobconfigBindingLoopLongLeftIcon,
  JobconfigBindingLoopLongRightIcon,
  JobconfigBindingLoopShortLeftIcon,
  JobconfigBindingLoopShortRightIcon,
  JobconfigBindingProClickLongLeftIcon,
  JobconfigBindingProClickLongRightIcon,
  JobconfigBindingProClickShortLeftIcon,
  JobconfigBindingProClickShortRightIcon,
  JobconfigBindingPerfectBoundLongLeftIcon,
  JobconfigBindingPerfectBoundLongRightIcon,
  JobconfigBindingPerfectBoundShortLeftIcon,
  JobconfigBindingPerfectBoundShortRightIcon,
  JobconfigBindingCornerLowerLeftLeftIcon,
  JobconfigBindingCornerLowerLeftRightIcon,
  JobconfigBindingCornerLowerRightLeftIcon,
  JobconfigBindingCornerLowerRightRightIcon,
  JobconfigBindingCornerUpperLeftLeftIcon,
  JobconfigBindingCornerUpperLeftRightIcon,
  JobconfigBindingCornerUpperRightLeftIcon,
  JobconfigBindingCornerUpperRightRightIcon,
  JobconfigBindingDRingIcon,
  JobconfigBindingRoundRingIcon,
  JobconfigPaperErrorTagIcon,
  JobconfigBannerEveryFeetIcon,
  JobconfigBannerCornersOnlyIcon,
  JobconfigBannerHemmingIcon,
  JobconfigRoundBaseIcon,
  DisabledCircleIcon,
  JobExpiredTipIcon,
  JobQuoteTrashIcon,
  ErrorExclamationPointIcon,
  RfqCheckIcon,
  RfqDownIcon,
  ExpertVersionnAddIcon,
  ExpertVersionnDeleteIcon,
  VectorIcon,
  RFQWarningIcon,
  RFQTableWarningIcon,
  NoteIcon,
  LeftOutlinedIcon,
  RightOutlinedIcon,
  FilterTipsIcon,
  GalleryListIcon,
  GalleryCardIcon,
  CompanyModalCloseIcon,
  ProjectAddIcon,
  ProjectSortIcon,
  ProjectJobDragIcon,
  ProjectCopyIcon,
  ProjectDeleteIcon,
  ProjectPdfIcon,
  ProjectViewIcon,
  ProjectCardDefaultIcon,
  ConfirmShippingDeleteIcon,
  ProjectSearchFilterIcon,
  ShippingUPSIcon,
  ShippingFedExIcon,
};
